import { createClient, type SupabaseClient } from '@supabase/supabase-js';

let cachedClient: SupabaseClient | null | undefined;

export function getSupabase(): SupabaseClient | null {
  if (cachedClient !== undefined) {
    return cachedClient;
  }

  const supabaseUrl =
    import.meta.env.NEXT_PUBLIC_SUPABASE_URL ?? import.meta.env.VITE_SUPABASE_URL;
  const publishableKey =
    import.meta.env.NEXT_PUBLIC_SUPABASE_PUBLISHABLE_DEFAULT_KEY ??
    import.meta.env.VITE_SUPABASE_PUBLISHABLE_DEFAULT_KEY;

  if (!supabaseUrl || !publishableKey) {
    if (import.meta.env.DEV) {
      console.warn(
        '[figtures] Supabase env eksik — .env.example dosyasını .env olarak kopyalayıp doldurun.',
      );
    }
    cachedClient = null;
    return null;
  }

  cachedClient = createClient(supabaseUrl, publishableKey);
  return cachedClient;
}

export function isSupabaseConfigured(): boolean {
  return getSupabase() !== null;
}
